import { Achievements as DefaultAchievements } from 'components';
import styled from 'styled-components';

export const AchievementsSection = styled(DefaultAchievements)``;
